





































































import Vue from 'vue';
import Component from 'vue-class-component';
import TitleMedium from '@/components/title/medium.vue';

@Component({
  components: {
    TitleMedium,
  },
})
export default class BoxModal extends Vue {

  /**
   * 表示フラグ
   */
  private show: boolean = false;

  /**
   * モーダル要素
   */
  private modal!: HTMLElement;

  /**
   * mountedフック
   */
  public mounted(): void {
    this.show = true;
  }

  /**
   * フェードアウト
   */
  public fadeOut(): void {
    this.show = false;
  }
}
